import { Radio, styled } from '@mui/material';

import { useStacklineTheme } from '@stackline/ui';
import React from 'react';
import { useDispatch } from 'react-redux';

import { setTimeline } from 'src/store/modules/adManager/adBudgetEditor/actions';
import { getTimelineOpt } from 'src/store/modules/adManager/adBudgetEditor/selectors';
import { useAppSelector } from 'src/utils/Hooks';
import { BudgetBuilderSectionHeader } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/common';

const PeriodContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,

  '.title_row': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 700
  },
  '.desc_row': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 400,
    marginLeft: '35px'
  }
});

const SectionContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  '.section_body': {
    display: 'flex',
    flexDirection: 'row'
  }
});

const PeriodEditor = () => {
  const theme = useStacklineTheme();
  const dispatch = useDispatch();
  const adBudgetEditor = useAppSelector((state) => state.adBudgetEditor);
  const retailer = useAppSelector((state) => state.retailer);
  const timelineOpt = getTimelineOpt(retailer);

  const updateTimeline = (value: any) => dispatch(setTimeline(value));
  return (
    <SectionContainer>
      <BudgetBuilderSectionHeader title="Budget Time Period" description="Select the time period for this budget." />

      <div className="section_body">
        {timelineOpt.map((timeline) => (
          <PeriodContainer
            role="button"
            key={timeline.id}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              updateTimeline(timeline);
            }}
          >
            <div className="title_row">
              <Radio
                checked={adBudgetEditor.timeline.id === timeline.id}
                disableRipple
                disableTouchRipple
                sx={{
                  svg: {
                    height: '15px',
                    width: '15px'
                  },
                  '&, &.Mui-checked': {
                    color: theme.colors.primary
                  }
                }}
              />
              <div className="">{timeline.displayName}</div>
            </div>
            <div className="desc_row">{timeline.disc}</div>
          </PeriodContainer>
        ))}
      </div>
    </SectionContainer>
  );
};

export default PeriodEditor;
